import { render, staticRenderFns } from "./ProofItem.vue?vue&type=template&id=26488d60&scoped=true&"
import script from "./ProofItem.vue?vue&type=script&lang=js&"
export * from "./ProofItem.vue?vue&type=script&lang=js&"
import style0 from "./ProofItem.vue?vue&type=style&index=0&id=26488d60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26488d60",
  null
  
)

export default component.exports